import React, { useCallback, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";

export default function BranchPricelistEditor(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, dataX, formName, setUpdateFlag } = props;
  const [docuDate, setDocuDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState(null);
  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.price_list_id === 0) {
      setData(null);
      goReady();
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/pricelist/get-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          setDocuDate(new Date(res.data.rows[0].docu_date));
          setStartDate(new Date(res.data.rows[0].begin_date));
          setEndDate(new Date(res.data.rows[0].end_date));
          goReady();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const fData1 = Object.fromEntries(dForm1);

    // delete year|month|day out
    delete fData1.year;
    delete fData1.month;
    delete fData1.day;

    if (fData1.docu_no === "") {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาระบุเลขเอกสาร",
          type: "error",
        })
      );
      return;
    }

    // if (fData1.contact_no ===""){
    //     dispatch(setReminder({show:true, message: "บันทีกโดยไม่ได้", type:'error'}))
    // }

    let dataToSave = {
      ItemId: selectedRow.row["price_list_id"],
      SaveInfo: { ...fData1, brchid: userDetail.brchid },
      UserDetail: userDetail,
    };

    if (selectedRow.custId === 0) {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        createby: userDetail.userid,
      };
    } else {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        updateby: userDetail.userid,
      };
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/pricelist/update",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const FILEDS = [
    { label: "เลขที่เอกสาร", oName: "docu_no", require: true, type: "text" },
    {
      label: "วันที่",
      oName: "docu_date",
      type: "date",
      state: [docuDate, setDocuDate],
    },
    {
      label: "ลูกค้า",
      oName: "custid",
      require: true,
      type: "select",
      rows: dataX && dataX.Custs && dataX.Custs,
    },
    { label: "เลขที่สัญญา", oName: "contract_no", require: true, type: "text" },
    {
      label: "เริ่มต้น",
      oName: "begin_date",
      type: "date",
      state: [startDate, setStartDate],
    },
    {
      label: "สินสุด",
      oName: "end_date",
      type: "date",
      state: [endDate, setEndDate],
    },
    { label: "ชื่อใช้งาน", oName: "descript", type: "text" },
  ];
  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal show={winState.show} size="xl" centered backdrop={false}>
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        {FILEDS ? (
          <FormAutoB
            {...{ formId: "form1", items: FILEDS, data: data, refTo: refForm1 }}
          />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
